
<template>
  <div class="home" v-wechat-title="simpleName">
      <div style="padding-top: 50px;text-align: center;">
          正在保存，稍后将跳转返回
      </div>
<!--      <div>-->
<!--          <button type="button" @click="goBack">点击</button>-->
<!--      </div>-->

  </div>
</template>


<script>
import wx from 'weixin-js-sdk';

export default {
    name: 'Index',
    data:function(){
        return {
            companyId:"",
            simpleName:"合同已签署",
            wxConfig:{}
        }
    },
    components: {

    },
    created() {
        // console.log(this.$route.params.id)
        // this.getWxConfig();
        this.goBack();
        // setTimeout(function (){
        //     this.goBack();
        // }, 1800);

    },
    methods: {
        goBack(){
            wx.miniProgram.navigateBack({
                delta: 1
            })
        },
        getWxConfig() {
            let that = this
            let url = window.location.href.split('#')[0]
            let api = that.baseUrl()+"/wx/wx/wxconfig";
            let data = {"url":url};
            that.$http.post(api,data).then(function(response){
                console.log("response:"+JSON.stringify(response))
                if(response.data.code == '1'){
                    that.wxConfig = response.data.data;
                    console.log("config:"+JSON.stringify(that.wxConfig))
                    wx.config({
                        debug: false,// 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: that.wxConfig.appId,         // 必填，公众号的唯一标识，填自己的！
                        timestamp: that.wxConfig.timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
                        nonceStr: that.wxConfig.nonceStr,   // 必填，生成签名的随机串
                        signature: that.wxConfig.signature, // 必填，签名，见附录1
                        jsApiList: [
                            // 'updateTimelineShareData',
                            // 'updateAppMessageShareData',
                            'hideMenuItems'
                        ]
                    })
                    wx.ready(function () {

                    })
                }

            }).catch(function(error){
                console.log("err:"+error);
            })


        }
    },
    computed:{

    }
}
</script>
